<template>
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12" v-for="input in inputs" :key="input.key">
      <div v-if="input.type === 'empty'"></div>
      <div v-else>
        <Textarea
          v-if="input.type === 'textarea'"
          v-model="projectDataLocal.purchasingOrder[input.key]"
          :placeholder="input.name"
          :viewMode="!canEdit"
        />
        <Input v-else v-model="projectDataLocal.purchasingOrder[input.key]" :placeholder="input.name" :viewMode="!canEdit" />
      </div>
    </div>
  </div>
</template>

<script>
import Input from '../../../../common/input';
import Textarea from '../../../../common/textarea';

export default {
  title: 'PurchasingOrder',
  components: {
    Input,
    Textarea,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      inputs: [
        {
          name: 'Document number',
          key: 'documentNumber',
        },
        {
          name: 'Purchase date',
          key: 'purchaseDate',
        },
        {
          name: 'purchasing_order_name',
          key: 'name',
        },
        {
          name: 'Name Buyer',
          key: 'nameBuyer',
        },
        {
          name: 'Delivery date',
          key: 'deliveryDate',
        },
        {
          name: 'Position number',
          key: 'positionNumber',
        },
        {
          name: 'Article number',
          key: 'articleNumber',
        },
        {
          name: 'Quantity',
          key: 'quantity',
        },
        {
          name: 'Machine number',
          key: 'maschineNumber',
        },
        {
          type: 'empty',
        },
        {
          name: 'Document description',
          key: 'documentDescription',
          type: 'textarea',
        },
      ],
    };
  },
  computed: {
    projectDataLocal: {
      get: function () {
        return this.projectData;
      },
      set: function (value) {
        this.$emit('projectData', value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
